/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_Select_DateInputs */

const es_components_ask_questions_label_select_date = /** @type {(inputs: Components_Ask_Questions_Label_Select_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar fecha`)
};

const en_components_ask_questions_label_select_date = /** @type {(inputs: Components_Ask_Questions_Label_Select_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a date`)
};

/**
* | output |
* | --- |
* | "Select a date" |
*
* @param {Components_Ask_Questions_Label_Select_DateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_select_date = /** @type {((inputs?: Components_Ask_Questions_Label_Select_DateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_Select_DateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_select_date(inputs)
	return en_components_ask_questions_label_select_date(inputs)
});
export { components_ask_questions_label_select_date as "components.ask_questions.label.select_date" }